import { useEffect, useState } from 'react'

export interface LayerToggles {
  district: boolean
  mandal: boolean
  sites: boolean
  shade: boolean
  issues: boolean
  legend: boolean
}

interface LayersPopoverProps {
  toggles: LayerToggles
  onChange: (key: keyof LayerToggles, value: boolean) => void
  /** On the Issues tab the hotspot overlay is forced on, so the control is checked + disabled. */
  issuesFocus: boolean
}

const ROW = 'flex cursor-pointer items-center gap-2 py-1 text-[13px]'
const H5 = 'text-muted-text mt-2.5 mb-1.5 text-[10px] font-bold tracking-wide uppercase first:mt-0'

export function LayersPopover({ toggles, onChange, issuesFocus }: LayersPopoverProps) {
  // Village is an honest stub: checking it flashes a "no data" note and unchecks (design §4).
  const [villageNote, setVillageNote] = useState(false)
  useEffect(() => {
    if (!villageNote) {
      return
    }
    const t = setTimeout(() => setVillageNote(false), 1800)
    return () => clearTimeout(t)
  }, [villageNote])

  return (
    <div className="absolute bottom-[60px] right-[18px] z-50 w-[220px] rounded-2xl border border-slate-900/10 bg-white/92 px-3.5 py-3 shadow-lg backdrop-blur-md">
      <h5 className={H5}>Boundaries</h5>
      <label className={ROW}>
        <input type="checkbox" checked={toggles.district} onChange={(e) => onChange('district', e.target.checked)} />
        District
      </label>
      <label className={ROW}>
        <input type="checkbox" checked={toggles.mandal} onChange={(e) => onChange('mandal', e.target.checked)} />
        Mandal
      </label>
      <label className={ROW}>
        <input type="checkbox" checked={false} onChange={() => setVillageNote(true)} />
        Village
        {villageNote && <span className="ml-auto text-[10px] text-amber-700">no data at this zoom</span>}
      </label>
      <h5 className={H5}>Operational</h5>
      <label className={ROW}>
        <input type="checkbox" checked={toggles.sites} onChange={(e) => onChange('sites', e.target.checked)} />
        Sites
      </label>
      <label className={ROW}>
        <input type="checkbox" checked={toggles.shade} onChange={(e) => onChange('shade', e.target.checked)} />
        Coverage shade
      </label>
      <label className={`${ROW} ${issuesFocus ? 'opacity-60' : ''}`}>
        <input
          type="checkbox"
          checked={issuesFocus || toggles.issues}
          disabled={issuesFocus}
          onChange={(e) => onChange('issues', e.target.checked)}
        />
        Issue hotspots
        {issuesFocus && <span className="text-muted-text ml-auto text-[10px]">auto on Issues tab</span>}
      </label>
      <h5 className={H5}>Display</h5>
      <label className={ROW}>
        <input type="checkbox" checked={toggles.legend} onChange={(e) => onChange('legend', e.target.checked)} />
        Legend
      </label>
    </div>
  )
}
